import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import userProcessor from '../../processor/userProcessor'
import vanBangBanSaoProcessor from '../../processor/vanBangBanSaoProcessor'
import ListVanBangWithView from '../VanBangBanChinh/ListVanBangWithView'
import ViewBanSao from './ViewBanSao'
import LichSuVanBangBanSao from './LichSuVanBangBanSao'
import store from '../../store/store'
import { setUsers } from '../../store/reducer/user'

const processor = vanBangBanSaoProcessor

export default function TaoMoiVanBangBanSao() {
  const [visible, setVisible] = useState(false)
  const [visible2, setVisible2] = useState(false)
  const [value, setValue] = useState({})
  const toast = useSelector((stores) => stores.notify.toast)

  const toggle = () => setVisible(!visible)
  const toggle2 = () => setVisible2(!visible2)
  const getUsers = async () => {
    const rs = await userProcessor.getByPermission('VanBangBanSaoChuaDuyet')
    store.dispatch(setUsers(rs.filter((item) => item.roleName !== 'Người nhập liệu')))
  }

  useEffect(() => {
    getUsers()
  }, [])
  const save = async (data) => {
    const rs = await processor.upsert(data)
    let message
    if (rs.isSuccess) {
      if (data.id) {
        message = rs.data
      } else {
        message = 'Thêm mới thành công'
      }
      toggle()
    } else {
      message = rs.data
    }
    toast({ type: rs.isSuccess ? 'success' : 'error', message })
    return rs
  }

  const buttons = [
    (data) => {
      return {
        icon: 'pi pi-plus',
        className: 'p-button-rounded p-button-success  mr-2',
        tooltip: 'Thêm',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          toggle()
          setValue({ vanBangId: data.id })
        },
      }
    },
    (data) => {
      return {
        icon: 'pi pi-history',
        className: 'p-button-rounded p-button-warning mr-2',
        tooltip: 'Lịch sử cấp phát',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          toggle2()
          setValue({ ...data })
        },
      }
    },
  ]
  return (
    <>
      <ViewBanSao visible={visible} toggle={toggle} data={value} submit={save} canEdit />
      <LichSuVanBangBanSao visible={visible2} toggle={toggle2} data={value} />
      <ListVanBangWithView moduleTitle="Tạo văn bằng bản sao" buttonsAfter={buttons} />
    </>
  )
}
